export default {
  'survey.action.back_home': '回到會員中心',
  'survey.cta.register': '立即加入會員',
  'survey.cta.view_coupon': '查看我的票券',
  'survey.cta.view_points': '查看我的點數',
  'survey.cta.go_member_center': '前往會員中心',
  'survey.cta.go_member_card': '前往會員卡',
  'survey.cta.go_coupon': '前往券匣',
  'survey.cta.register_to_claim': '先註冊再領 🎁',
  'survey.cta.join_member': '我要加入會員！',
  'survey.welcome.question_count': '{count} 題',
  'survey.welcome.estimated_minutes': '約 {minutes} 分鐘',
  'survey.welcome.start': '開始填寫',
  'survey.welcome.privacy': '填寫即表示同意隱私權政策',
  'survey.welcome.privacy_prefix': '填寫即表示同意',
  'survey.reward.title': '您的專屬好禮',
  'survey.reward.member_points': '會員點數',
  'survey.reward.point_unit': '點',
  'survey.reward.points': '{points} 點',
  'survey.reward.coupon': '{name}{qty}',
  'survey.reward.coupon_fallback': '優惠券',
  'survey.reward.require_member': '加入會員即可領取獎勵',
  'survey.question.unsupported': '暫不支援此題型',
  'survey.question.auth_required': '請先完成 LINE 登入後再送出問卷。',
  'survey.question.submit_failed': '送出失敗，請稍後再試。',
  'survey.question.required': '必填',
  'survey.footer.submitting': '送出中...',
  'survey.footer.submit': '送出',
  'survey.footer.next': '下一步',
  'survey.footer.back': '上一步',
  'survey.progress.label': '問題 {current}/{total}',
  'survey.district.city': '縣市',
  'survey.district.city_placeholder': '請選擇縣市',
  'survey.district.township': '行政區',
  'survey.district.township_placeholder': '請選擇行政區',
  'survey.text.placeholder': '請輸入您的回答...',
  'survey.multi_choice.selected_count': '已選擇 {count} 項',
  'survey.rating.1': '非常不滿意',
  'survey.rating.2': '不滿意',
  'survey.rating.3': '普通',
  'survey.rating.4': '滿意',
  'survey.rating.5': '非常滿意',
  'survey.rating.aria_label': '{score} 分，{label}',
  'survey.rating.placeholder': '請選擇評分',
  'survey.complete.thanks': '感謝您的填答！',
  'survey.complete.submitted': '問卷已成功送出。',
  'survey.error.SVY001.title': '找不到此問卷',
  'survey.error.SVY001.content': '此問卷不存在或已被移除。',
  'survey.error.SVY002.title': '此問卷目前未開放填寫',
  'survey.error.SVY002.content': '請確認問卷連結或稍後再試。',
  'survey.error.SVY003.not_started.title': '此問卷尚未開放',
  'survey.error.SVY003.not_started.content': '預計 {date} 開始。',
  'survey.error.SVY003.ended.title': '此問卷已結束填寫',
  'survey.error.SVY003.ended.content': '填寫期限至 {date}。',
  'survey.error.SVY003.title': '此問卷尚未開放或已結束',
  'survey.error.SVY003.content': '請確認問卷開放時間。',
  'survey.error.SVY009.title': '此邀請已過期',
  'survey.error.SVY009.content': '感謝您的關注。',
  'survey.error.SVY010.title': '此連結非屬於您',
  'survey.error.SVY010.content': '您無法使用這個問卷連結填寫。',
  'survey.error.SVYF009.title': '此門市暫停服務',
  'survey.error.SVYF009.content': '請改用其他門市問卷連結，或稍後再試。',
  'survey.error.E001.title': '問卷連結無效',
  'survey.error.E001.content': '請確認您開啟的是完整問卷連結。',
  'survey.error.auth_required.title': '無法開啟問卷',
  'survey.error.auth_required.content': '請先完成 LINE 登入後再開啟問卷。',
  'survey.error.default.title': '無法開啟問卷',
  'survey.error.default.content': '問卷驗證失敗，請稍後再試。',
  'survey.filled.title': '您已填寫過此問卷',
  'survey.filled.content': '此問卷僅供填寫一次，感謝您的參與。',
  'survey.filled.recent.content':
    '您已於 {completedDate} 填寫，下次可填寫時間為 {nextOpenDate}',
} as Record<string, string>;
